// @ts-ignore
import {RgPostMessageAPI} from 'relax/RgPostMessageAPI.esm';
import {EventManagerWithAsync} from '@fantasmagames/core/src/events/EventManagerWithAsync';

export class MessagesAPI {
	public static readonly AUTOPLAY_PAUSED: string = 'MessagesAPI::AUTOPLAY_PAUSED';
	public static readonly GAME_HARD_PAUSED: string = 'MessagesAPI::GAME_HARD_PAUSED';
	public static readonly GAME_RESUMED: string = 'MessagesAPI::GAME_HARD_PAUSED';
	public static readonly BALANCE_UPDATED: string = 'MessagesAPI::BALANCE_UPDATED';

	public static init(eventManager: EventManagerWithAsync): void {
		RgPostMessageAPI.init(true, undefined, null);

		window.addEventListener('rg_pause', (evt: Event) => {
			if ((evt as any).data && (evt as any).data.autoPlayOnly) {
				eventManager.emit(MessagesAPI.AUTOPLAY_PAUSED);
			} else {
				/* A hard pause. Once any unfinished round has completed, disable
				controls(so a new round cannot be started), pause autoplay, and
				call ​RgPostMessageAPI.reportPaused().​ */
				eventManager.emit(MessagesAPI.GAME_HARD_PAUSED);
				RgPostMessageAPI.reportPaused(null);
			}
		});

		window.addEventListener('rg_resume', () => {
			/* Reality check was closed; the game can now continue.   Re-enable controls and resume autoplay if it was paused by   'rg_pause' */
			eventManager.emit(MessagesAPI.GAME_RESUMED);
		});

		window.addEventListener('rg_updateBalance', () => {
			// Account balance has changed.
			// Request balance by calling /game/getbalance.
			eventManager.emit(MessagesAPI.BALANCE_UPDATED);
		});
	}

	public static gameReady(): void {
		RgPostMessageAPI.reportGameReady();
	}

	public static gameRoundStarted(): void {
		RgPostMessageAPI.gameRoundStarted();
	}

	public static gameRoundFinished(): void {
		RgPostMessageAPI.gameRoundEnded();
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/logic/relax/MessagesAPI.ts